export enum Routes {
  CREDIT_SIMULATION_INTRO = '/',
  CREDIT_SIMULATION_VALUE = '/value',
  CREDIT_SIMULATION_INSTALLMENTS = '/installments',
  CREDIT_SIMULATION_SUMMARY = '/summary',
  CREDIT_SIMULATION_CONFIRMATION = '/confirmation',
}

export const RoutesHistory = {
  [Routes.CREDIT_SIMULATION_INTRO]: '',
  [Routes.CREDIT_SIMULATION_VALUE]: '',
  [Routes.CREDIT_SIMULATION_INSTALLMENTS]: '',
  [Routes.CREDIT_SIMULATION_SUMMARY]: '',
  [Routes.CREDIT_SIMULATION_CONFIRMATION]: '',
};
